<script lang="ts" setup>
import { useProductPageStore } from "~/stores/main";

interface Color {
  name: string;
  value: string;
  selectable: boolean;
}

const props = withDefaults(
  defineProps<{
    colors: Color[];
    selected: string | null;
    store?: any;
  }>(),
  {
    selected: null,
    store: null,
  },
);

// Use injected store or fallback to default
const store = props.store || useProductPageStore();
const { t } = useI18n();

const focusedColor = ref<string | null>(null);
const colorName = computed(() => {
  if (focusedColor.value !== null) {
    return focusedColor.value;
  }

  if (props.selected !== null) {
    return props.selected;
  }

  return "";
});

defineEmits(["change"]);
</script>

<template>
  <div>
    <div class="flex items-center px-2.5 h-[50px]">
      <h3 class="font-bold text-base lg:text-xl">
        {{ t("color") }}
      </h3>
      <span v-if="colorName !== ''" class="ml-5 pt-[2px]">{{ colorName }}</span>
    </div>
    <div
      v-if="store.masterProduct?.stock ?? 0 > 0"
      class="mt-2 lg:mt-4 xl:mt-2.5 px-2.5"
    >
      <BasePaletteDot
        v-for="color in colors"
        :key="color.name"
        :color="color.name"
        :palette="color.value"
        :disabled="!color.selectable"
        :selected="color.name == selected"
        class="mr-2.5"
        @click="$emit('change', color.name)"
        @mouseover="focusedColor = color.name"
        @mouseleave="focusedColor = null"
      >
      </BasePaletteDot>
    </div>
  </div>
</template>
